import './index.scss';

const DeadEnd = ({title, subtitle}) => {
  return (
    <div>
      <div className="dead-end-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 295.996 295.996">
          <defs />
          <path d="M147.998 0C66.392 0 0 66.392 0 147.998s66.392 147.998 147.998 147.998 147.998-66.392 147.998-147.998S229.605 0 147.998 0zm0 279.996c-36.256 0-69.143-14.696-93.022-38.44a132.713 132.713 0 01-23.934-32.42C21.442 190.847 16 170.047 16 147.998 16 75.214 75.214 16 147.998 16c34.523 0 65.987 13.328 89.533 35.102 12.208 11.288 22.289 24.844 29.558 39.996 8.27 17.239 12.907 36.538 12.907 56.9 0 72.784-59.214 131.998-131.998 131.998z" />
          <circle cx="99.666" cy="114.998" r="16" />
          <circle cx="198.666" cy="114.998" r="16" />
          <path d="M147.715 229.995c30.954 0 60.619-15.83 77.604-42.113l-13.439-8.684c-15.597 24.135-44.126 37.604-72.693 34.308-22.262-2.567-42.849-15.393-55.072-34.308l-13.438 8.684c14.79 22.889 39.716 38.409 66.676 41.519 3.461.399 6.917.594 10.362.594z" />
        </svg>
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
      </div>
    </div>
  );
};

export default DeadEnd;
